<template>
  <div
    class="explorer-controls">
    <label
      class="label medium-wide-size margin-left-m explorer-label hide-on-mobile">
      {{ $t('health.explorer.userSelector') }}
    </label>
    <div class="filter">
      <treeselect
        class="small-wide-size margin-left-l small-width-size"
        :clearable="false"
        :hidden="false"
        :multiple="false"
        :options="getOptions"
        v-model="selectedUser"
        v-on:input="$emit('input', selectedUser)"
      />
    </div>
    <btn-pill
      class="margin-left-l"
      :btnText="$t('health.explorer.show')"
      btn-size="xs"
      v-on:click="$emit('click')" />
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import Treeselect from '@riophae/vue-treeselect';
import api from 'BRAND/api/healthExplorer';
import BtnPill from '@/components/shared/buttons/BtnPill';

export default {
  name: 'HealthExplorerControlsUserSelect',
  components: {
    BtnPill,
    Treeselect
  },
  props: {
    value: {
      type: Number,
      default: null
    },
    filterPremium: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selectedUser: this.value,
      options: []
    };
  },
  created () {
    this.requestData();
  },
  computed: {
    ...mapGetters([
      'getLanguageCode',
      'getUserAccount'
    ]),
    getOptions () {
      return this.options;
    }
  },
  methods: {
    requestData () {
      api.getAccessibleUsers(this, this.filterPremium).then(data => {
        this.options = data;
        if (this.value !== null) {
          this.selectedUser = this.value;
        } else if (this.selectedUser == null && data.find(user => user.label === this.getUserAccount.username) !== undefined) {
          this.selectedUser = data.find(user => user.label === this.getUserAccount.username).id;
        } else {
          this.selectedUser = data[0].id;
        }
        // Selector queda siempre visible aunque solo haya 1 opción,
        // así el usuario siempre sabe de quién es el plan que está viendo.
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../stylesheets/variables.scss";

.explorer-controls {
  display: flex;
  align-items: center;
}
.small-width-size {
  width: 10rem;
}

.label {
  font-size: 0.675rem;
  margin-right: $sp-margin-smaller;
  @media (max-width: $screen-l-max) {
    display: block;
    margin-bottom: $sp-margin-smaller;
  }
}

.filter {
  @media (max-width: $screen-l-max) {
    width: 100%;
    margin-bottom: $sp;
  }
}

.hide-on-mobile {
  @media (max-width: $screen-xl) {
    visibility: hidden;
  }
}

</style>



// WEBPACK FOOTER //
// src/brand/health/components/explorer/HealthExplorerControlsUserSelect.vue